export const SET_REQUEST_STATUS = 'SET_REQUEST_STATUS';
export const USERS_PUSH = 'USERS_PUSH';
export const USERS_RESET = 'USERS_RESET';
export const USERS_GET = 'USERS_GET';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_DELETE = 'USER_DELETE';
export const USER_SAVE = 'USER_SAVE';
export const USER_ADD = 'USER_ADD';
